const exclusions = [
  "Manufacturing defects",
  "Wear and tear or cosmetic scratches",
  "Misuse, negligence or unauthorised repairs",
  "Consumables — brushes, filters, mop cloths, batteries",
  "Theft, loss, commercial or rental use",
  "Damage in transit",
];

export default function NotCovered() {
  return (
    <section className="tw-bg-[#F7F7F8] tw-py-[88px]">
      <div className="tw-max-w-[1120px] tw-mx-auto tw-px-6 xl:tw-px-0">
        {/* Heading */}
        <div className="tw-flex tw-flex-col tw-items-center tw-gap-3.5 tw-text-center tw-mb-12">
          <h2 className="tw-text-3xl md:tw-text-[40px] tw-leading-[normal] tw-font-semibold tw-tracking-[-0.01em] tw-text-[#111]">
            What the plan doesn’t cover
          </h2>
          <p className="tw-max-w-[720px] tw-text-base md:tw-text-[17px] tw-leading-[27px] tw-text-[#6B7280]">
            A few things sit outside accidental damage. The Terms list
            everything in full.
          </p>
        </div>

        {/* Cards */}
        <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-4 tw-items-start">
          {exclusions.map((item) => (
            <div
              key={item}
              className="tw-flex tw-items-center tw-gap-3 tw-bg-white tw-rounded-[14px] tw-px-5 tw-py-[18px] tw-text-[15px]"
            >
              <span className="tw-shrink-0 tw-font-bold tw-text-[#D93F3F]">
                ✕
              </span>
              <span className="tw-font-medium tw-leading-[22px] tw-text-[#111]">
                {item}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
